export default "__VITE_ASSET__DadJUC0l__"